import './panel-menu-item.css';

import { Ripple } from 'primereact/ripple';

import { MenuItem } from '../../../pages/mindmap/types';
import { InputText } from '../input-text/input-text';

type PanelMenuItemProps = MenuItem & { children?: MenuItem[] };

export const PanelMenuItem = ({
  expanded,
  disabled,
  icon,
  label,
  onClick,
  type,
  onChange,
  value,
  autoselect,
}: PanelMenuItemProps) => {
  const isInputText = type == 'input-text';

  return isInputText ? (
    <li className={`p-ripple p-menuitem ${expanded ? 'p-menuitem-active' : ' '}`} onClick={onClick}>
      <InputText
        name="panel-menu-item-input"
        autoFocus={autoselect}
        value={value}
        placeholder={label}
        noErrorPadding={true}
        className="panel-menu-input"
        onChange={onChange}
      />
    </li>
  ) : (
    <li className={`p-ripple p-menuitem ${expanded ? 'p-menuitem-active' : ' '}`} onClick={onClick}>
      <a className={`p-menuitem-link ${disabled ? 'p-disabled' : ''}`} role="menuitem" aria-haspopup="true">
        <span className={`p-menuitem-icon ${icon}`}></span>
        <span className={'p-menuitem-text'}>{label}</span>
        <span className="p-submenu-icon"></span>
        {/* 
            // @ts-ignore */}
        <Ripple ripple={true} />
      </a>
    </li>
  );
};
